import React from 'react';
import classnames from 'classnames';
import { CircularProgress } from '@mui/material';
import PanelView from '../PanelView';
import TreeView from './TreeView';
import { ReactComponent as Expand } from 'js/components/elements/treeview/assets/expandMoreFilled.svg';
import _ from 'lodash';
import cx from 'classnames';
import { SearchInjector } from 'new/elements/SearchableProvider/SearchInjector';

class TreeViewNode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  _handleNodeSelected = (event) => {
    event.stopPropagation();

    const shouldSelectItem =
      (this.props.enableFileSelection &&
        (!this.props.selectableFileMimeType ||
          this.props.node.mimeType === this.props.selectableFileMimeType)) ||
      this.props.node.type === 'folder';

    if (!shouldSelectItem) return;

    this.props.onNodeSelected(this.props.node, this.props.node.id);
  };

  _handleNodeExpandClicked = (event) => {
    event.stopPropagation();

    const { node, onNodeExpandClicked } = this.props;
    const { scanned, children } = node;

    onNodeExpandClicked(node);
    if (!scanned && (!children || _.isEmpty(children))) {
      this.setState({ loading: true });
    }
  };

  render() {
    const {
      node,
      nodeKeyName,
      level,
      iconClasses,
      nodeElement,
      onNodePreview,
      onNodeSelected,
      onNodeExpandClicked,
      selectedNodeId,
      enableFileSelection,
      selectableFileMimeType,
    } = this.props;

    var isParent = node[nodeKeyName || 'nodes'] ? true : false;

    var isRoot = isParent && level === 1 ? true : false;

    var isSelected = node.id === selectedNodeId;

    var iconClass =
      isParent === true
        ? isRoot === true
          ? iconClasses.top
          : iconClasses.nodes
        : iconClasses.leaf;

    var rowContent = React.cloneElement(nodeElement, {
      node: node,
      level: level,
      onNodePreview: onNodePreview,
      onNodeSelected: onNodeSelected,
      onNodeExpandClicked: onNodeExpandClicked,
      selectedNodeId: selectedNodeId,
      iconClass: iconClass,
      enableFileSelection: enableFileSelection,
      selectableFileMimeType: selectableFileMimeType,
    });
    var children = node[nodeKeyName || 'nodes'];
    var childrenPanel =
      children && !_.isEmpty(children) ? (
        <PanelView expanded={node.open}>{this._renderChildNodes()}</PanelView>
      ) : null;

    if (!childrenPanel && node.type === 'folder' && node.scanned) {
      childrenPanel = (
        <PanelView expanded={node.open}>
          <div
            style={{
              textAlign: 'center',
              padding: '10px',
              borderBottom: '1px solid #dfe8f0',
            }}
          >
            Empty folder. No files found
          </div>
        </PanelView>
      );
    }

    var contentClass = classnames(
      'treeview-node-content',
      node && node.level > 1 ? 'has-children' : '',
      {
        selected: isSelected,
      },
    );

    var folderButton;

    if (this.state.loading && node.scanned === false && !node.error) {
      folderButton = (
        <CircularProgress
          size={16}
          thickness={4}
          color="primary"
          style={{ verticalAlign: 'middle', marginRight: 'var(--spacing-sm)' }}
          className="loading-spinner"
        />
      );
    } else if (childrenPanel || !node.scanned) {
      folderButton = (
        <div
          className="expand-icon-button"
          data-testid={`expand-button-${node.name}`}
          onClick={this._handleNodeExpandClicked}
        >
          <Expand
            className={cx('expand', {
              ['expand-open']: node.open,
              ['expand-close']: !node.open,
            })}
          />
        </div>
      );
    }

    if (node.type === 'file') {
      folderButton = <div className="treeview-node-handler" style={{ width: 12, height: 12 }} />;
    }

    return (
      <li
        className={classnames('treeview-node', {
          'has-children': children && !_.isEmpty(children),
        })}
        data-testid={`file-node-detail-${node.id}`}
      >
        <div className={contentClass} onClick={this._handleNodeSelected}>
          <span className="treeview-node-handler">{folderButton}</span>
          <div className="treeview-node-detail">{rowContent}</div>
        </div>
        {childrenPanel}
      </li>
    );
  }

  _renderChildNodes = () => {
    const nodeKeyName = this.props.nodeKeyName || 'nodes';

    var childNodes = this.props.node[nodeKeyName];
    if (!Array.isArray(childNodes)) {
      childNodes = childNodes ? [childNodes] : [];
    }

    return (
      <SearchInjector>
        <TreeView
          data={childNodes}
          selectedNodeId={this.props.selectedNodeId}
          selectable={true}
          enableFileSelection={this.props.enableFileSelection}
          selectableFileMimeType={this.props.selectableFileMimeType}
          nodeKeyName={this.props.nodeKeyName}
          iconClasses={this.props.iconClasses}
          nodeElement={this.props.nodeElement}
          onNodePreview={this.props.onNodePreview}
          onNodeSelected={this.props.onNodeSelected}
          onNodeExpandClicked={this.props.onNodeExpandClicked}
        />
      </SearchInjector>
    );
  };
}

export default TreeViewNode;
